import AppImage from '@/components/ui/AppImage';
import Tower from '../../img/tower.jpg';
import Building1 from '../../img/building1.jpg';
import Building2 from '../../img/building2.jpg';
import Bridge from '../../img/bridge.jpg';

const btsPhotos = [
  {
    id: 'bts_1',
    image: Building2.src,
    alt: 'Old building with intricate details and historic charm in architectural photography setting',
  },
  {
    id: 'bts_2',
    image: Tower.src,
    alt: 'Tower in the distance with dramatic sky and vibrant colors in nature photography setting',
  },
  {
    id: 'bts_3',
    image: Bridge.src,
    alt: 'Bridge over water with scenic surroundings in landscape photography setting',
  },
  {
    id: 'bts_4',
    image: Building1.src,
    alt: 'Modern building with sleek architecture and well-designed interior in architectural photography setting',
  },
];

export default function BTSSection() {
  return (
    <section className="py-16">
      <div className="reveal">
        <h3 className="text-3xl font-bold text-white mb-8">Stunning Landscape</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {btsPhotos?.map((photo) => (
            <div
              key={photo?.id}
              className="relative aspect-square rounded-xl overflow-hidden group"
            >
              <AppImage
                src={photo?.image}
                alt={photo?.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-background/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
